import { PaymentRequestApproveItemsUseCase } from '../../../application';

export default class PaymentRequestApproveItemsService {

    async execute(event) {
        const data = await PaymentRequestApproveItemsUseCase(event);
        return data;
    }
}
